import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'CTLCurrentDrawings',
            headers: {},
            args: {},
            urlArgs: {
                ...payload,
            },
        });
        return result;
    };
};
